import React from "react";
import "../css/AfterEvent.css";

const AfterEvent = () => {
  return (
    <section className="afterevent-section">
      <div className="container text-center mb-5">
        <h1>AFTER EVENT LKTIN 2026</h1>
        <iframe width="100%" height="560" src="https://www.youtube.com/embed/K94L31bRuz4?si=aOn47hrW6fWDz4KG" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      </div>
    </section>
  );
};

export default AfterEvent;
